import * as React from 'react'

interface Props {
  style?: React.CSSProperties
  className?: string
}

const Component: React.FC<Props> = ({ style, className }) => (
  <footer className={className} style={style}>
    <a href="/assets/利用規約.pdf" className="footer-terms-link" target="_blank">
      利用規約
    </a>
    <a href="/assets/特商法に基づく表示.pdf" className="footer-terms-link" target="_blank">
      特商法に基づく表示
    </a>
    <a href="https://e-commus.co.jp/privacy.html" className="footer-terms-link" target="_blank" rel="noreferrer">
      プライバシーポリシー
    </a>
    <p className="footer-copyright">Copyright © 株式会社イー・コミュニケーションズ All Rights Reserved.</p>
  </footer>
)

export default Component
